'use client';
import React from 'react';
import Hero from './hero';
import Content from './content';
import Table from './table';
import Backforward from '../backforward';
import Twako from '../../componenets/tawko2';
import Navbar from '@/app/componenets/Navbar';
import Footer from '@/app/componenets/Footer';
export default function page() {
  return (
    <div>
      <title>
        A Luxury Car Service To Elevate Your Next Vacation Trip To New Jersey
      </title>
      <meta
        name="description"
        content="Searching for a professional luxury car service to make your trip to New Jersey memorable? Look no further than this blog to find the perfect service for your next vacation."
      />

      {/* <!-- Facebook Meta Tags --> */}
      <meta property="og:url" content="https://www.prestigeride.com" />
      <meta property="og:type" content="website" />
      <meta
        property="og:title"
        content="A Luxury Car Service To Elevate Your Next Vacation Trip To New Jersey"
      />
      <meta
        property="og:description"
        content="Searching for a professional luxury car service to make your trip to New Jersey memorable? Look no further than this blog to find the perfect service for your next vacation."
      />
      <meta
        property="og:image"
        content="https://www.prestigeride.com/updated-home/twitterCArd.jpg"
      />

      <meta name="twitter:card" content="summary_large_image" />
      <meta property="twitter:domain" content="prestigeride.com" />
      <meta property="twitter:url" content="https://www.prestigeride.com" />
      <meta
        name="twitter:title"
        content="A Luxury Car Service To Elevate Your Next Vacation Trip To New Jersey"
      />
      <meta
        name="twitter:description"
        content="Searching for a professional luxury car service to make your trip to New Jersey memorable? Look no further than this blog to find the perfect service for your next vacation."
      />
      <meta
        name="twitter:image"
        content="https://www.prestigeride.com/updated-home/twitterCArd.jpg"
      />
      <meta name="robots" content="index, follow" />
      <link
        rel="canonical"
        href="https://www.prestigeride.com/blog/first-class-travel-vacation-new-jersey"
      />
      <Navbar />
      <Hero />
      <Content />
      <Table />
      <Backforward />
      <Twako />
      <Footer />
    </div>
  );
}
